import { render } from "./PageTitlebar.vue?vue&type=template&id=3216910c&scoped=true"
import script from "./PageTitlebar.vue?vue&type=script&lang=js"
export * from "./PageTitlebar.vue?vue&type=script&lang=js"

import "./PageTitlebar.vue?vue&type=style&index=0&id=3216910c&scoped=true&lang=scss"

import exportComponent from "/var/www/production/releases/51/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3216910c"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QCard});
